module.exports = __webpack_public_path__ + "catalog/items/canteencart/canteen_cart.png";